import React, { useCallback } from 'react'

// Wrapping a bad component
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { ClickAwayListener, ClickAwayListenerProps } from '@material-ui/core'

import { OmitStrict } from '../common/tsUtils'

export type ProperClickAwayListenerProps =
  OmitStrict<ClickAwayListenerProps, 'onClickAway'>
  & {
  isOpen: boolean

  onClose: VoidFunction
}

export const ProperClickAwayListener =
  ({isOpen, onClose, ...passProps}: ProperClickAwayListenerProps) => {
    const handleClickAway =
      useCallback((e: React.MouseEvent<Document, MouseEvent>) => {
        // NOTE: This callback is called when clicking anywhere on the page, once per instance of this component
        if (!isOpen) {
          return
        }

        // If the above check isn't enough, try this for distinguishing different instances of this component
        // anchor is the first child element
        /*if (e.target instanceof Node && anchorRef.current.contains(e.target)) {
          return
        }*/

        e.stopPropagation()
        e.preventDefault()

        onClose()
      }, [isOpen, onClose])

    return <ClickAwayListener onClickAway={handleClickAway} {...passProps}/>
  }